import { selectCustomerInfo } from "src/stores/calllogs";
import { CallerInfo } from "./CallerInfo";
import CallerHeader from "./calllogsHeader";
import { ExistingQuery } from "./ExistingQuery";
import { QueueInfo } from "./QueueInfo";
import { useSelector } from "react-redux";

export const IncomingCall = ({ callerInfo }) => {
  const customerInfo = useSelector(selectCustomerInfo);
  const result = customerInfo?.data?.result;

  const hasQueueInfo =
    callerInfo?.callActionInput && callerInfo?.callActionQueue;

  return (
    <>
      <CallerHeader callerInfo={callerInfo} />
      <CallerInfo callerInfo={callerInfo} />

      {hasQueueInfo && <QueueInfo callerInfo={callerInfo} />}
      {result && <ExistingQuery />}
    </>
  );
};
